import { createSelector } from "reselect";

import type { NodeId } from "~/models/dto";
import { identity } from "~/tools/identity";

import { createDeepEqualSelector } from "../../../generic/redux/SelectorUtils";
import type { VisualizerSelection } from "../../../stackviz/rendering/utils/VisualizerSelectionStorage";
import { selectAllSearchParams } from "../route/RouteSelectors";

import { RightPaneState } from "./RightPaneState";

export const selectRightPaneState = createDeepEqualSelector(
	createSelector(selectAllSearchParams, ({ rightPane = RightPaneState.defaults }) => rightPane),
	identity,
);

const selectCurrentRightPanelItem = createSelector([selectRightPaneState], RightPaneState.getCurrentItem);

export const selectRightPaneCanGoBack = createSelector(
	[selectRightPaneState],
	(rightPane) => rightPane.activeTab === "selection" && rightPane.chain.length > 1,
);

export const selectRightPaneElementId = createSelector(selectCurrentRightPanelItem, (panelItem) => {
	if (panelItem?.type === "component" || panelItem?.type === "relation") {
		return panelItem.id;
	}

	return undefined;
});

export const selectRightPaneEventId = createSelector(selectCurrentRightPanelItem, (panelItem) => {
	if (panelItem?.type === "event") {
		return panelItem.id;
	}

	return undefined;
});

export const selectRightPaneSpanEntry = createSelector(selectCurrentRightPanelItem, (panelItem) => {
	if (panelItem?.type === "span" || panelItem?.type === "span-event") {
		return panelItem;
	}

	return undefined;
});

export const selectCurrentSelection = createSelector(
	[selectCurrentRightPanelItem, selectRightPaneElementId],
	(paneItem, elementId): VisualizerSelection => ({
		elementId: elementId as NodeId,
		groupId: paneItem?.type === "group" ? (paneItem.id as NodeId) : undefined,
		indirectRelationId: paneItem?.type === "indirect-relation" ? (paneItem.id as NodeId) : undefined,
		groupRelationId: paneItem?.type === "group-relation" ? (paneItem.id as NodeId) : undefined,
	}),
);
